import React, { useMemo } from 'react';

import { observer } from 'mobx-react';

import { LbPagination } from '@infoods/lifebase-ui';

import classes from './UnreadScansTable.module.scss';
import { TitleRow } from './TitleRow/TitleRow';
import { ScanRow } from './ScanRow/ScanRow';
import { EmptyList } from '../../../../shared/components/ui-components';
import { unreadScansStore } from '../../../stores/unreadScansStore';
import {
  COLUMN_WIDTHS,
  ShowColumnsConfig,
  UNREAD_SCANS_COLUMN,
  UNREAD_SCANS_TABLE_MODE,
  UnreadScansTableMode,
} from './UnreadScansTable.settings';
import { getVisibleColumns } from '../../../../shared/components/table-components';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

type UnreadScansTableProps = {
  // tableMode is passed as prop (not derived from filter store's solutionType)
  // because column visibility is a display concern separate from data filtering
  tableMode: UnreadScansTableMode;
};

const UnreadScansTable = observer(({ tableMode }: UnreadScansTableProps) => {
  const { isCoach } = loggedInUserDataStore;
  const { unreadScans, filterMethods } = unreadScansStore;
  const { isShowPlaceholder, totalElements, elementsPerPage, getPaginationProps } =
    filterMethods;

  const showColumnsConfig = useMemo<ShowColumnsConfig>(
    () => ({
      [UNREAD_SCANS_COLUMN.NAME]: true,
      [UNREAD_SCANS_COLUMN.SOLUTION]: tableMode === UNREAD_SCANS_TABLE_MODE.ALL,
      [UNREAD_SCANS_COLUMN.COACH]:
        !isCoach &&
        (tableMode === UNREAD_SCANS_TABLE_MODE.NUTRITION ||
          tableMode === UNREAD_SCANS_TABLE_MODE.ALL),
      [UNREAD_SCANS_COLUMN.ACTIVE_SINCE]: true,
      [UNREAD_SCANS_COLUMN.DATE_OF_UPDATE]: true,
    }),
    [tableMode, isCoach],
  );

  const { visibleColumns, gridTemplateColumns } = getVisibleColumns({
    columnEnum: UNREAD_SCANS_COLUMN,
    showColumnsConfig,
    columnWidths: COLUMN_WIDTHS,
  });

  return (
    <>
      <div className={classes.unreadScansTable} style={{ gridTemplateColumns }}>
        <TitleRow visibleColumns={visibleColumns} />
        {unreadScans.map((scan) => {
          //We need to combine user id and solution type to avoid duplicate keys on dashboard mixed-solution table
          const key = scan.id + scan.solutionType;
          return <ScanRow key={key} scanInfo={scan} visibleColumns={visibleColumns} />;
        })}
      </div>
      <EmptyList
        show={isShowPlaceholder}
        description="There are no unread scans"
        size="small"
      />
      <LbPagination
        totalElements={totalElements}
        elementsPerPage={elementsPerPage}
        variant="inBox"
        {...getPaginationProps()}
      />
    </>
  );
});

export { UnreadScansTable };
